import { Components } from '@mui/material/styles'

export const MuiSelect: Components['MuiSelect'] = {
  styleOverrides: {
    select: {
      padding: '4px 16px 4px 0',
      lineHeight: '23px',
      fontSize: '14px',
    },
  },
}
